import { createFileRoute, useRouter } from '@tanstack/react-router';

import { ROUTES } from '@/constants/routes';
import { ForgotPasswordForm } from '@/features/authentication/ForgotPasswordForm';
import { AuthenticationLayout } from '@/layouts/AuthenticationLayout';

function ForgotPasswordPage() {
  const router = useRouter();
  return (
    <AuthenticationLayout
      title="Forgot Password"
      description="Enter your admin email address to receive a reset link."
      backLabel="Back to Sign In"
      onBack={() => void router.navigate({ to: ROUTES.signIn })}
    >
      <ForgotPasswordForm />
    </AuthenticationLayout>
  );
}

export const Route = createFileRoute('/admin/forgot-password')({
  component: ForgotPasswordPage,
});
